import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { observer } from "mobx-react-lite";
import { useAlarmWizardStore } from "../AlarmWizard/useAlarmWizardStore";
import { ALARM_STEPS_CONFIG, stepsLength } from "../AlarmWizard/AlarmWizardStore";

export const WizardStepIndicator = observer(() => {
	const state = useAlarmWizardStore();
	const step = state.currentStep;
	return (
		<div className="flex items-center justify-between px-2">
			{ALARM_STEPS_CONFIG.map(({ label }, index) => {
				const isCompleted = index < step;
				const isActive = index === step;

				return (
					<div key={label} className="flex items-center flex-1 last:flex-none">
						<div className="flex flex-col items-center gap-1.5">
							<div
								className={cn(
									"flex items-center justify-center size-8 rounded-full text-sm font-medium border-2 transition-colors",
									isCompleted && "bg-primary border-primary text-primary-foreground",
									isActive && "border-primary text-primary bg-primary/10",
									!isCompleted && !isActive && "border-muted-foreground/30 text-muted-foreground",
								)}
							>
								{isCompleted ? <Check className="size-4" /> : index + 1}
							</div>
							<span
								className={cn(
									"text-xs font-medium",
									isActive && "text-primary",
									isCompleted && "text-foreground",
									!isCompleted && !isActive && "text-muted-foreground",
								)}
							>
								{label}
							</span>
						</div>
						{index < stepsLength - 1 && (
							<div
								className={cn(
									"flex-1 h-0.5 mx-3 mb-5 rounded-full",
									index < step ? "bg-primary" : "bg-muted-foreground/20",
								)}
							/>
						)}
					</div>
				);
			})}
		</div>
	);
});
